import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrequel = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1229 203",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Layer_2",
		"data-name": "Layer 2",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Layer_1-2",
			"data-name": "Layer 1",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M22.67,105.1v77.29H0V2.06H68.26c34.27,0,53.59,19.58,53.59,51.52S102.53,105.1,68.26,105.1ZM67.75,83.47c20.35,0,30.66-10,30.66-29.89S88.1,23.7,67.75,23.7H22.67V83.47Z",
					style: { fill: "#141414" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M265.59,182.39l-52.81-85H182.64v85H160V2.06h63.11c33,0,53.07,16.49,53.07,47.66,0,25.5-12.62,41-37.61,46.11l53.84,86.56ZM182.64,23.7v52h41c19.32,0,29.11-8.76,29.11-26s-9.79-26-29.11-26Z",
					style: { fill: "#141414" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M322.51,2.06H436.89V23.7H345.18V75.48H424V97.12H345.18v63.63h94.29v21.64h-117Z",
					style: { fill: "#141414" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M595.31,151.47l16.75,16.75-15.71,16.23L580.89,169c-11.59,10.31-25.76,15.46-42.25,15.46-20.61,0-37.35-8-50.49-23.7-13.14-16-19.58-38.9-19.58-68.53S475,39.67,488.15,24C501.29,8,518,0,538.64,0S576,8,589.13,24c13.14,15.71,19.58,38.64,19.58,68.26C608.71,116.18,604.33,136,595.31,151.47Zm-48.43-17,15.72-16.23,16,16.23c4.38-11.59,6.7-25.5,6.7-42.25,0-24.21-4.13-42-12.63-53.32-8.5-11.59-19.83-17.26-34-17.26s-25.5,5.67-34,17.26C496.14,50.23,492,68,492,92.22c0,48.44,18,70.59,46.63,70.59,10.56,0,19.58-3.09,26.79-9.27Z",
					style: { fill: "#141414" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M639.62,2.06h22.67V121.34c0,24.72,15.19,41.47,41.21,41.47s41.22-16.75,41.22-41.47V2.06h22.67V119.79c0,20.09-5.93,35.8-18,47.4s-27.31,17.26-45.86,17.26-33.74-5.67-45.85-17.26-18-27.31-18-47.4Z",
					style: { fill: "#141414" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M806.8,2.06H921.18V23.7H829.47V75.48H908.3V97.12H829.47v63.63h94.28v21.64h-117Z",
					style: { fill: "#141414" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M1076.51,182.39H961.87V2.06h22.67V160.75h92Z",
					style: { fill: "#141414" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M1105.35,203V182.39H1229V203Z",
					style: { fill: "#141414" }
				})
			]
		})
	})
});
export default SvgPrequel;
